module.exports = "a62a37e2c2118bc5cfc1aec584f96269.png";


//////////////////
// WEBPACK FOOTER
// ./assets/sprites/shrine-top-r-4.png
// module id = 65
// module chunks = 0